module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        loadWhenPrimaryKeyPresentOnly: true,
        resourceRegisterKey: 'productsAdditionalInformationProperties',
        isFullyVertical: true,
    },

    model: {
        preventSubmit: true,
    },
}
